import { render, staticRenderFns } from "./VxListAggregator.vue?vue&type=template&id=2f7a7647&scoped=true"
import script from "./VxListAggregator.vue?vue&type=script&lang=js"
export * from "./VxListAggregator.vue?vue&type=script&lang=js"
import style0 from "./VxListAggregator.vue?vue&type=style&index=0&id=2f7a7647&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a7647",
  null
  
)

export default component.exports